import "./Footer.css";
import logo from "../../assets/Optimiz Color.png";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <div>
      <footer className="main-footer">
        <div className="container footer-container">
          {/* ✅ Left Section - About */}
          <div className="footer-about">
            <div className="footer-logo">
              <a href="/">
                <img
                  src={logo}
                  alt="Optimiz Logo"
                  className="footer-logo-img"
                />
              </a>
            </div>
            <p>The all-in-one platform to manage your business operations.</p>
          </div>

          {/* ✅ Right Section - Links */}
          <div className="footer-links">
            <div className="footer-column">
              <h4>Company</h4>
              <a href="#">About Us</a>
              <a href="/contact-us">Contact</a>
              <a href="/privacy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </div>

            {/* ✅ Info Section with Icons */}
            <div className="footer-column">
              <h4>Info</h4>
              <div className="footer-info">
                <p>
                  <FaMapMarkerAlt className="footer-icon" /> Ahemdabad, Gujrat,
                  India
                </p>
                <p>
                  <FaPhoneAlt className="footer-icon" /> +91 9737949264
                </p>
                <p>
                  <FaEnvelope className="footer-icon" />
                  <a href="mailto:info@dhanveen.com">info@dhanveen.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* ✅ Horizontal Line */}
      {/* <div className="footer-separator"></div> */}

      {/* ✅ Bottom Bar with Social Icons and Copyright */}
      <div className="bottom-container">
        <div className="bottom-content">
          {/* ✅ Social Media Icons */}
          <div className="social-icons">
            {/* <a href="#" aria-label="Facebook">
              <FaFacebookF />
            </a> */}
            <a
              href="https://www.instagram.com/accounts/login/?next=%2Foptimiz_official%2F&source=omni_redirect"
              target="_blank"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            {/* <a href="#" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a> */}
          </div>

          {/* ✅ Copyright */}
          <p>&copy; {new Date().getFullYear()} Optimiz. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
